// ? 全局默认配置项
export const CDN_URL = "https://static.zhihaoscm.cn/";
export const OSS_URL = "https://zhihaoscm-public.oss-cn-hangzhou.aliyuncs.com";
// 首页地址（默认）
export const HOME_URL: string = "/dashboard/index";

// 登录页地址（默认）
export const LOGIN_URL: string = "/login";

// 全匹配路由名(默认)
export const MATCH_NAME: string = "matchAll";

// 默认主题颜色
export const DEFAULT_PRIMARY: string = "#1777FF";

// 路由白名单地址（本地存在的路由 staticRouter.ts 中）
export const ROUTER_WHITE_LIST: string[] = ["/500", "/403"];

// 高德地图 web云服务 key
export const AMAP_MAP_WEB_KEY: string = "2c93a1b3e2cb4e43e173c50caa49792d";

// 日期时间选择器格式化
export const DATETIME_PICKER_FORMAT = "YYYY-MM-DD HH:mm";
export const DATE_PICKER_FORMAT = "YYYY-MM-DD";

// 时间戳格式化带T
export const LOG_DATE_FORMAT_T = "YYYY-MM-DDTHH:mm:ss";
export const DATETIME_PICKER_FORMAT_T = "YYYY-MM-DDTHH:mm:00";

// 日志时间戳格式化
export const LOG_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss";
export const LOG_DATE_FORMAT_START = "YYYY-MM-DDT00:00:00";
export const LOG_DATE_FORMAT_END = "YYYY-MM-DDT23:59:59";
export const TIME_PICKER_FORMAT = "HH:mm:ss";
// 海康摄像头时间戳格式化
export const HIA_DATE_FORMAT = "YYYYMMDDHHmmss";

// 新增、修改弹框宽度
export const DEFAULT_DIALOG_WIDTH = "842px";
export const W900_DIALOG_WIDTH = "900px";
export const W1100_DIALOG_WIDTH = "1100px";
export const VW90_DIALOG_WIDTH = "90%";

// 上传导入Excel文件格式
export const UploadExcelFileType = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"];

// 指数管理批量上传模板
export const ProductTypeIndexFileName =
    CDN_URL +
    "template/%E6%8C%87%E6%95%B0%E7%AE%A1%E7%90%86%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF%20.xlsx";

// 链云水尺表导入模板
export const WaterGaugeIndexFileName =
    CDN_URL + "template/%E9%93%BE%E4%BA%91%E6%B0%B4%E5%B0%BA%E8%A1%A8%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// 船舶信息联系方式导入模板
export const ContactInformationIndexFileName =
    CDN_URL + "template/%E5%AF%BC%E5%85%A5%E8%81%94%E7%B3%BB%E6%96%B9%E5%BC%8F%E6%A8%A1%E7%89%88.xlsx";

// AI热词导入模板
export const AiIntelligentAssistantIndexFileName =
    CDN_URL + "template/AI%E7%83%AD%E8%AF%8D%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BF.xlsx";

// 油品指数批量上传模板
export const OilIndexUploadFileName =
    CDN_URL +
    "template/%E6%B2%B9%E5%93%81%E6%8C%87%E6%95%B0%E7%AE%A1%E7%90%86%E6%89%B9%E9%87%8F%E4%B8%8A%E4%BC%A0%E6%A8%A1%E6%9D%BF-2.29.0.xlsx";

// 选项卡最大数量
export const MAX_TAG_NUMBER = 10;

// 数据缺省值
export const DEFAULT_VALUE = "--";

// 权重最大值
export const MAX_WEIGHT = 999;

export const VideoPlayerUrl = `${import.meta.env.VITE_VIDEO_PLAYER_URL}?{dateRange}token={token}&deviceSerial={deviceSerial}&mode={mode}&origin={origin}`;

/**
 * 管理后台响应式栅格配置
 */
export const responseConfig = {
    xs: 24,
    sm: 24,
    md: 12,
    lg: 8,
    xl: 6
};
